var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    className: "text-black w-16 h-16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.793 3.587 17.538 9.2c-.925 1.594-3.237 1.594-4.162 0l-3.255-5.612L8.118 0h14.708l-2.033 3.587Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.435 3.934 3.244 5.619c.918 1.598-.235 3.582-2.078 3.586H.005L7.374.364l2.061 3.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.457 3.934-3.243 5.619c-.919 1.598.235 3.582 2.078 3.586H30.887L23.52.364l-2.061 3.57ZM10.1 23.487l3.255-5.612c.925-1.595 3.237-1.595 4.162 0l3.255 5.612 2.003 3.587H8.067l2.033-3.587ZM21.457 23.14l-3.243-5.62c-.919-1.597.235-3.582 2.078-3.585H30.887L23.52 26.71l-2.061-3.57ZM9.435 23.14l3.244-5.62c.918-1.597-.235-3.582-2.078-3.585H.005L7.374 26.71l2.061-3.57Z"
  })));
};
export default SvgLogoNoText;